
const state = function () {
  return {
    notifications: []
  }
}

export default {
  ...state()
}

export const initialState = state()
